import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deleteBusinessMaster,
  listBusinessMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * BusinessMaster 削除 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * optimistic locking: expected_updated_at を request に含める。
 */
export function useDeleteBusinessMaster(): InvalidatingMutationResultFor<
  typeof deleteBusinessMaster
> {
  return useInvalidatingMutation(deleteBusinessMaster, [
    createConnectQueryKey({
      schema: listBusinessMasters,
      cardinality: 'finite',
    }),
  ])
}
